import get from 'lodash/get'

export const getHelicopterDataCsvFileId = (state, id) => get(state, ['vegetation', 'helicopterData', 'csvFileId'])
export const getHelicopterDataImagesFileId = (state, id) => get(state, ['vegetation', 'helicopterData', 'imagesFileId'])
export const getHelicopterDataDefectFile = (state, id) => get(state, ['vegetation', 'helicopterData', 'defects'])

export const isLoadingHelicopterImport = (state) => get(state, ['vegetation', 'helicopterData', 'loading'])


// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/helicopterData.js